import { render } from "./OrganisationNew.vue?vue&type=template&id=60e1e95a&scoped=true"
import script from "./OrganisationNew.vue?vue&type=script&lang=js"
export * from "./OrganisationNew.vue?vue&type=script&lang=js"

import "./OrganisationNew.vue?vue&type=style&index=0&id=60e1e95a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60e1e95a"

export default script